export class AuditClaimNote {
  ClientId: number;
  RawDataImport_ShardClaimIdentifier: number;
  NoteId: number;
  NoteText: string;
  Tmstmp: Date;
  UserID: string;
  Source: string;
}